import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest, merge } from 'rxjs';
import { AuthService } from '../../../../../../src/core/services/auth.service';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../../core/services/apiHelper';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class EditCaptainsResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private userDAO: UserDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const userResolve = this.userDAO.loadById(route.params.id);
    const sessionResolve = this.authService.checkSession();
    return combineLatest([userResolve, sessionResolve]).pipe(
      map(([userResolve, sessionResolve]) => ({ userResolve, sessionResolve })),
      take(1),
    );
  }
}
